import PropTypes from 'prop-types';
import React from 'react';
import CustomerPaymentViewHeader from './CustomerPaymentViewHeader';
import Icon, { GLYPHS } from '../../common/icon';
import Spinner from '../../main/customers/customersList/spinner';

const CustomerPaymentView = ({ close, total, loading, children, subtitle, header }) => (
  <div className="o-customer-payment-view u-fadein">

    <div className="o-customer-payment-view__controls" display-if={close}>
      <button type="button" className="c-btn c-btn--blank" onClick={close}>
        <Icon glyph={GLYPHS.arrowXClose} size="medium" />
      </button>
    </div>

    <CustomerPaymentViewHeader total={total} subtitle={subtitle}>
      {header}
    </CustomerPaymentViewHeader>

    <div className="o-customer-payment-view__loader">
      <div className="u-inline-block">
        <Spinner display-if={loading} />
      </div>
    </div>

    <div className="o-customer-payment-view__main">
      {children}
    </div>

  </div>
  );
CustomerPaymentView.propTypes = {
  close: PropTypes.func,
  total: PropTypes.number,
  loading: PropTypes.bool,
  children: PropTypes.node,
  subtitle: PropTypes.string,
  header: PropTypes.node,
};
CustomerPaymentView.defaultProps = {
  close: null,
  total: null,
  subtitle: '',
  children: null,
  loading: false,
  header: null,
};

export default CustomerPaymentView;
